import styled from "styled-components";

import { Field } from "src/components-v2";

import { colors } from "src/assets/styles/settings";
import { AccountNumberFieldProps, AccountNumberNameProps } from "./";

export const FieldAccountNumber = styled(Field)<Partial<AccountNumberFieldProps>>`
  border-right: 0;
  border-bottom-left-radius: ${({ isShow }) => isShow && 0};
`;

export const AccountNumberName = styled.div<AccountNumberNameProps>`
  background-color: ${({ isSuccess, isWrong }) =>
    isSuccess ? colors.light_jade : isWrong ? colors.sakura : colors.white};
  border: 1px solid ${colors.light_grey};
  border-radius: 0 0 4px 4px;
  border-top: 0;
  padding: 12px 16px;
  width: 100%;
  order: 5;
`;
